import { IProduct } from '@interfaces';

import { imgV2 as img } from '@styles/utils';

import styles from '@components/common/products/product.styles';

export default function BundleNeurosurgeonFounded({ bundle }: { bundle?: IProduct }) {

    return (
        <div className={styles.bundleNeurosurgeonFounded}>
            <h3>Bundle Neurosurgeon Founded</h3>
            <h2>real science, real food</h2>
            <div className="cerebelly-labels">
                <div className="product-sugar">
                    <div>
                        <span className="number">
                            0
                            <span className="grams">g</span>
                        </span>
                    </div>
                    <div>
                        <span className="heading">no added sugar</span>
                    </div>
                </div>
                <div>
                    <div>
                        <img src={img('pdp2/claim-badges/USDA.svg')} alt="" />
                    </div>
                    <div>
                        <span className="heading">certified organic, veggie-first ingredients</span>
                    </div>
                </div>
                <div className="product-nutrients">
                    <div>
                        <span className="number">16</span>
                    </div>
                    <div>
                        <span className="heading">brain-supporting nutrients in every bite</span>
                    </div>
                </div>
            </div>
        </div>
    );
}